export const locale = {
    lang: 'pl',
    data: {
        'Current version': 'Aktualna wersja',

    }
};
